import toast from "react-hot-toast";
import { appGetItem } from "./appStorage";
import { forceAuthLogout } from "./authSession";
import oneSignalService from "../services/oneSignalService";

export const isBasicPlanUser = () => {
  const planType = (appGetItem("plan_type") || "").trim();
  if (planType === "Basic") return true;

  const planStatus = parseInt(appGetItem("plan_status"), 10);
  return planStatus === 1;
};

export const getCurrentUserId = () => appGetItem("user_id");

export const isOtherUser = (targetUserId) => {
  if (targetUserId == null || targetUserId === "") return false;

  const currentId = getCurrentUserId();
  if (!currentId) return false;

  return String(targetUserId) !== String(currentId);
};

const BASIC_PLAN_OTHER_USER_MESSAGE =
  "Basic plan is mobile-only. Please use the app or upgrade to access other users on web.";

export const logoutBasicPlanUser = (navigate, { message, toastType = "error" } = {}) => {
  oneSignalService.removeExternalUserId().catch(() => {});
  forceAuthLogout();

  if (message) {
    if (toastType === "success") {
      toast.success(message);
    } else {
      toast.error(message);
    }
  }

  if (typeof navigate === "function") {
    navigate("/login", { replace: true });
    return;
  }

  window.location.href = "/login";
};

export const enforceBasicPlanNoOtherUsersAccess = (targetUserId, navigate) => {
  if (!isBasicPlanUser() || !isOtherUser(targetUserId)) return false;

  logoutBasicPlanUser(navigate, { message: BASIC_PLAN_OTHER_USER_MESSAGE });
  return true;
};

const BLOCKED_WEB_APP_ROUTE_PATTERNS = [
  /^\/personal-info\/?$/,
  /^\/contact\/?$/,
  /^\/groupchat\/?$/,
  /^\/creategroup\/?$/,
  /^\/chat\/?$/,
  /^\/notifications\/?$/,
];

export const shouldRedirectBasicPlanToPayment = () => isBasicPlanUser();
export const shouldLogoutBasicPlanForRoute = (pathname, search = "") => {
  if (!isBasicPlanUser()) return false;

  const path = pathname || "";

  const friendMatch = path.match(/^\/friend-profile\/([^/]+)/);
  if (friendMatch && isOtherUser(friendMatch[1])) return true;

  const chatMatch = path.match(/^\/chat\/([^/]+)/);
  if (chatMatch && isOtherUser(chatMatch[1])) return true;

  if (BLOCKED_WEB_APP_ROUTE_PATTERNS.some((pattern) => pattern.test(path))) return true;

  const chatUserId = new URLSearchParams(search).get("user_id");
  if (chatUserId && isOtherUser(chatUserId)) return true;

  return false;
};
